import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  UpdateEnvironmentVariableRequestType,
  UpdateEnvironmentVariableResponseType
} from "./types";

export const updateEnvironmentVariableRequest = ({
  variable,
  fields
}: UpdateEnvironmentVariableRequestType) =>
  apiProxyRequest<UpdateEnvironmentVariableResponseType>(
    `${variable?._links?.["#edit"]?.href}`,
    "PATCH",
    fields
  );
